import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  LOCALE_ID,
  Inject,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  DOCUMENT
} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Options } from '@angular-slider/ngx-slider';
import {
  HotelEnterpriseSearchInterface,
  HotelQuoteResult,
  filtersKeys,
  SearchHandler,
  AmenitiesSearchHandler,
  ExtraSearchHandler,
  HotelDetails,
  RoomType,
  TravelPolicies,
  StarRating,
  CustomerRating,
  HotelUIStarsUserFavoriteResponse
} from '@sabstravtech/obtservices/base';
import {
  ServiceType,
  EnterpriseSearchService,
  UserService,
  HotelAvalibilityService,
  WithSubscriptionComponent
} from '@sabstravtech/obtservices/angular';

import { LightningUserFavorurite } from '../../../../core/classes/user-favourite.enum';
import { HotelTagEnum } from '../../../../core/enum/hotel-tag.enum';
import { ThemeService } from '../../../../core/services/theme.service';

@Component({
  selector: 'app-filter-hotels',
  templateUrl: './filter-hotels.component.html',
  styleUrls: ['./filter-hotels.component.scss'],
  standalone: false
})
export class FilterHotelsComponent extends WithSubscriptionComponent implements OnInit, OnChanges {
  @Input() srchRslts: any;
  @Input() swapSellHotelGroup: string;
  @Input() hotels: HotelQuoteResult[];
  @Input() viewControl: any;
  @Input() showFilts: boolean;
  @Output() availabilityFilter: EventEmitter<boolean> = new EventEmitter<boolean>();

  amenityTypeList: string[];
  chainTypeList: string[];
  hotelPriceRange: number[];
  hotelName: string;
  formFilter: FormGroup = new FormGroup({
    HotelName: new FormControl('')
  });
  amenitiesShowMore = false;
  chainsShowMore = false;
  priceOptions: Options;
  hotelNameTimeout = null;
  public showIt = false;
  maxPrice = 0;
  minPrice = 0;
  readonly Defaulttop10amenty: AmenitiesSearchHandler[] = [
    AmenitiesSearchHandler.AIR_CONDITIONING,
    AmenitiesSearchHandler.BUSINESS_CENTRE,
    AmenitiesSearchHandler.EXPRESS_CHECKOUT,
    AmenitiesSearchHandler.GOLF_FACILITIES,
    AmenitiesSearchHandler.PARKING,
    AmenitiesSearchHandler.RESTAURANT,
    AmenitiesSearchHandler.SWIMMING_POOL,
    AmenitiesSearchHandler.WHEELCHAIR_ACCESS,
    AmenitiesSearchHandler.WIFI,
    AmenitiesSearchHandler.ON_SITE_SAFE,
    AmenitiesSearchHandler.ROOM_SERVICE_24_HOUR,
    AmenitiesSearchHandler.ELECTRIC_CAR_CHARGING_POINT,
    AmenitiesSearchHandler.ECO_FRIENDLY,
    AmenitiesSearchHandler.PETS_ALLOWED
  ];

  readonly extra: string[] = [
    SearchHandler.AVAILABILITY,
    SearchHandler.FEMALE_FRIENDLY,
    SearchHandler.LONE_TRAVELLER
  ];
  readonly preferred: string[] = [SearchHandler.ANY, SearchHandler.AGENCY, SearchHandler.CLIENT];
  readonly travelPolicies: string[] = [TravelPolicies.ALLOW_WITH_REASON, TravelPolicies.IN_POLICY];
  readonly starRating: string[] = [
    StarRating.TwoStar,
    StarRating.ThreeStar,
    StarRating.FourStar,
    StarRating.FiveStar,
    StarRating.Unrated
  ];
  readonly customerRating: string[] = [
    CustomerRating.OneStar,
    CustomerRating.TwoStar,
    CustomerRating.ThreeStar,
    CustomerRating.FourStar,
    CustomerRating.FiveStar,
    CustomerRating.Unrated
  ];
  readonly preferredCrown: string[] = [SearchHandler.CROWN_ONLY, SearchHandler.NON_CROWN_ONLY];
  readonly preferredRateList: string[] = [
    SearchHandler.TMC_PREFERRED,
    SearchHandler.COMPANY_PREFERRED,
    SearchHandler.OFFICE_PREFERRED
  ];
  readonly refundableRoomTypeList: string[] = [
    SearchHandler.REFUNDABLE,
    SearchHandler.NON_REFUNDABLE
  ];
  readonly roomTypeList: string[] = [
    RoomType.SingleRoom,
    RoomType.DoubleRoom,
    RoomType.TwinRoom,
    RoomType.QueenRoom,
    RoomType.KingRoom,
    RoomType.Suite
  ];

  readonly breakfastFilters: string[] = [
    SearchHandler.BREAKFAST_INCLUDED,
    SearchHandler.BREAKFAST_NOT_INCLUDED
  ];

  readonly amenityTypeListAdditional: string[] = [
    ExtraSearchHandler.GREEN_HOTEL,
    ExtraSearchHandler.ACCESSIBLE_ROOM,
    ExtraSearchHandler.CTM_PARTNERS
  ];

  SearchHandler: typeof SearchHandler = SearchHandler;
  ExtraSearchHandler: typeof ExtraSearchHandler = ExtraSearchHandler;
  AmenitiesSearchHandler: typeof AmenitiesSearchHandler = AmenitiesSearchHandler;
  public searchParams: HotelEnterpriseSearchInterface;
  isScion = false;
  get top10amenty(): { [key: string]: boolean } {
    const additionalFiltersHotel =
      this.userService.getUserFavoriteValue(LightningUserFavorurite.additionalFiletersHotel) || '';
    return [...this.Defaulttop10amenty, ...additionalFiltersHotel.split('|')].reduce(
      (current: { [key: string]: boolean }, amenity: string) => {
        if (amenity) {
          current[amenity] = true;
        }
        return current;
      },
      {}
    );
  }

  // Unified checkbox state management
  checkboxStates: Record<string, Record<string, boolean>> = {
    facilities: {},
    extra: {},
    breakfast: {},
    preference: {},
    preferenceCrown: {},
    preferenceRate: {},
    chain: {},
    refundable: {},
    travelPolicy: {},
    starRating: {},
    customerRating: {},
    amenityTypes: {}
  };

  isFCDOApprovedHotel = false;
  hotelTagEnum = HotelTagEnum;
  crownSet = false;
  public hotelStarRatingsToHide = {
    [StarRating.TwoStar]: false,
    [StarRating.ThreeStar]: false,
    [StarRating.FourStar]: false,
    [StarRating.FiveStar]: false
  };
  firstTimeSetup = true;

  // Filter configuration for state management - maps stateKey to items getter and filter key
  private readonly filterStateConfig: Array<{
    stateKey: string;
    getItems: () => string[];
    filterKey?: string;
  }> = [
    { stateKey: 'facilities', getItems: () => this.amenityTypeList, filterKey: 'amenitytype' },
    { stateKey: 'extra', getItems: () => this.extra, filterKey: 'extra' },
    {
      stateKey: 'refundable',
      getItems: () => this.refundableRoomTypeList,
      filterKey: 'refundableRoomType'
    },
    { stateKey: 'breakfast', getItems: () => this.breakfastFilters, filterKey: 'breakfastType' },
    { stateKey: 'travelPolicy', getItems: () => this.travelPolicies, filterKey: 'travelPolicy' },
    { stateKey: 'preference', getItems: () => this.preferred, filterKey: 'preferred' },
    {
      stateKey: 'preferenceCrown',
      getItems: () => this.preferredCrown,
      filterKey: 'crownPreferred'
    },
    {
      stateKey: 'preferenceRate',
      getItems: () => this.preferredRateList,
      filterKey: 'preferredRate'
    },
    { stateKey: 'chain', getItems: () => this.chainTypeList, filterKey: 'chain' },
    {
      stateKey: 'amenityTypes',
      getItems: () => this.amenityTypeListAdditional,
      filterKey: 'amenitytype'
    }
  ];

  constructor(
    public searchService: EnterpriseSearchService,
    @Inject(LOCALE_ID) public readonly locale: string,
    private userService: UserService,
    private cd: ChangeDetectorRef,
    public hotelAvalibilityService: HotelAvalibilityService,
    @Inject(DOCUMENT) private document: Document,
    public themeService: ThemeService
  ) {
    super();
    this.searchParams = this.searchService.searches[ServiceType.Hotel];
    console.log(this.searchParams.maxPrice);
    console.log(this.searchParams.filters.priceRange);
  }

  /**
   * Helper to initialise all items in a state object to a given value
   */
  private initStateItems(stateKey: string, items: string[], value = false): void {
    items.forEach((item) => {
      this.checkboxStates[stateKey][item] = value;
    });
  }

  /**
   * Helper to update state items based on filter inclusion
   */
  private updateStateFromFilter(stateKey: string, items: string[], filterKey: string): void {
    const filterArray = this.searchParams.filters[filterKey] || [];
    items.forEach((item) => {
      this.checkboxStates[stateKey][item] = filterArray.includes(item);
    });
  }

  ngOnInit(): void {
    this.crownSet = this.userService.crownIsSet();
    console.warn(this.searchParams.filters);

    this.amenityTypeList = [];
    this.chainTypeList = [];
    this.hotelPriceRange = [];
    this.createOptionsList();
    this.setPreferredOptions();
    this.setPriceFilterValues();
    this.subscribe(this.searchParams.hotelRoomReceived, (data: boolean) => {
      if (data) {
        this.setPriceFilterValues();
        this.initialiseStates(true);
      }
    });
    if (this.themeService.isScionEnv) {
      this.isScion = true;
    }
    this.isFCDOApprovedHotel = this.searchParams.resultsHaveTag(HotelTagEnum.FCDOApprovedHotel);
    if (this.searchParams.pendingChatbotFilters) {
      // Arrived from the chatbot's "View Full Results" — keep the filters it
      // applied instead of clearing them. Reflect them in the checkbox UI and
      // position the price slider, then re-run the client-side filter.
      this.searchParams.pendingChatbotFilters = false;
      this.updateStates();
      this.setPriceFilterValues();
      const priceRange = this.searchParams.filters.priceRange;
      const hasChatPrice = priceRange.min > 0 || priceRange.max < Number.MAX_SAFE_INTEGER;
      if (hasChatPrice) {
        this.minPrice = priceRange.min;
        this.maxPrice =
          priceRange.max < Number.MAX_SAFE_INTEGER ? priceRange.max : this.hotelPriceRange[1];
      }
      this.searchParams.filterLighteningResults();
    } else {
      this.clearFilters();
    }
    if (this.searchParams.filters.crownPreferred.includes(SearchHandler.CROWN_ONLY)) {
      this.checkboxStates.preferenceCrown[SearchHandler.CROWN_ONLY] = true;
    }
    this.firstTimeSetup = false;
    this.subscribe(this.searchParams.results, () => {
      setTimeout(() => {
        this.updateStates();
      }, 0);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.swapSellHotelGroup) {
      const currentValues = changes.swapSellHotelGroup.currentValue;
      if (Array.isArray(currentValues)) {
        currentValues.forEach((currentValue) => {
          this.checkboxStates.chain[currentValue] = true;
        });
      } else {
        this.checkboxStates.chain[currentValues] = true;
      }
    }
  }

  setPriceFilterValues(): void {
    let min: number, max: number;
    const minValue = [];
    const maxValue = [];
    if (
      Math.round(this.hotelPriceRange[0]) !== Math.round(this.searchParams.filters.priceRange.min)
    ) {
      min = this.searchParams.filters.priceRange.min;
    }
    if (
      Math.round(this.hotelPriceRange[1]) !== Math.round(this.searchParams.filters.priceRange.max)
    ) {
      max = this.searchParams.filters.priceRange.max;
    }

    this.searchParams.fullResults.forEach((hotel: HotelDetails) => {
      const availability = this.searchParams.getAvaliability(hotel);
      if (availability && Object.keys(availability).length !== 0 && availability?.rooms[0]) {
        const conversion = availability?.rooms[0]?.currencyConversion?.rate || 1;
        // minValue
        minValue.push(availability.prpn * conversion);
        // maxValue
        if (availability?.maxprice) {
          maxValue.push(availability.maxprice * conversion);
        } else {
          maxValue.push(
            availability?.rooms.reduce((op, item) => (op = op > item.total ? op : item.total), 0)
          );
        }
      }
    });

    const minPrice = minValue.length ? Math.min(...minValue) : 0;
    const maxPrice = maxValue.length
      ? Math.max(...maxValue)
      : this.searchParams.filters.priceRange.max;
    this.searchParams.filters.perNightPriceRange.min = this.searchParams.filters.priceRange.min =
      min || minPrice;
    this.searchParams.filters.perNightPriceRange.max = this.searchParams.filters.priceRange.max =
      max || maxPrice;
    this.hotelPriceRange = [minPrice, maxPrice];
  }

  setPreferredOptions(): void {
    const Any = 'Any';
    const Client = 'Client';
    const Agency = 'Agency';

    // this.srchRslts.forEach((hotel: Hotel) => {
    //   if (+hotel.Preferred === 1 && !this.preferred.includes(Client)) {
    //     this.preferred.push(Client);
    //   }

    //   if (+hotel.Preferred === 2 && !this.preferred.includes(Agency)) {
    //     this.preferred.push(Agency);
    //   }

    //   if (+hotel.Preferred === 3 && !this.preferred.includes(Any)) {
    //     this.preferred.push(Any);
    //   }
    // });
  }

  createOptionsList(): void {
    const top10amenty = this.top10amenty;
    const [cHeckChain1]: [{ [key: string]: boolean }] = this.searchParams.results.value.reduce(
      ([cHeckChain]: [{ [key: string]: boolean }], hotel) => {
        if (!cHeckChain[hotel.group]) {
          cHeckChain[hotel.group] = true;
        }
        return [cHeckChain];
      },
      [{}]
    );

    this.amenityTypeList = Object.keys(top10amenty)
      .filter((item) => !this.searchParams.hiddenAmenitiesFilters[item])
      .sort((a, b) => this.sortAmenities(a, b));
    this.initialiseStates();
    this.chainTypeList = Object.keys(cHeckChain1).sort();
  }

  sortAmenities(a: string, b: string): number {
    // Place ECO_FRIENDLY first
    if (a === AmenitiesSearchHandler.ECO_FRIENDLY) {
      return -1;
    }
    if (b === AmenitiesSearchHandler.ECO_FRIENDLY) {
      return 1;
    }

    // Default sorting
    return a.localeCompare(b);
  }

  initialiseStates(applyFilters = false) {
    // Initialise all filter states to false using config
    this.filterStateConfig.forEach(({ stateKey, getItems }) => {
      this.initStateItems(stateKey, getItems());
    });

    // roomTypeList also uses preference state
    this.initStateItems('preference', this.roomTypeList);

    // Apply user's star rating visibility preferences
    const uiConfigHotelRatings =
      this.userService.getUserFavoriteObject<HotelUIStarsUserFavoriteResponse>(
        LightningUserFavorurite.hotelPreferredImage
      );
    if (uiConfigHotelRatings?.hotelStarsToHide) {
      const starHideMap = {
        hideTwoStarHotels: StarRating.TwoStar,
        hideThreeStarHotels: StarRating.ThreeStar,
        hideFourStarHotels: StarRating.FourStar,
        hideFiveStarHotels: StarRating.FiveStar
      };
      Object.entries(starHideMap).forEach(([configKey, rating]) => {
        if (uiConfigHotelRatings.hotelStarsToHide[configKey]) {
          this.hotelStarRatingsToHide[rating] = true;
        }
      });
    }

    // Apply user's default filter preferences
    if (uiConfigHotelRatings?.hotelDefaultFilters) {
      const defaults = uiConfigHotelRatings.hotelDefaultFilters;

      if (defaults.breakfastIncluded) {
        this.checkboxStates.breakfast[SearchHandler.BREAKFAST_INCLUDED] = true;
        this.applyFilter({ checked: true }, SearchHandler.BREAKFAST_INCLUDED, 'breakfastType');
      }

      if (defaults.breakfastNotIncluded) {
        this.checkboxStates.breakfast[SearchHandler.BREAKFAST_NOT_INCLUDED] = true;
        this.applyFilter({ checked: true }, SearchHandler.BREAKFAST_NOT_INCLUDED, 'breakfastType');
      }

      if (defaults.refundable) {
        this.searchParams.hiddenExtraFilters[ExtraSearchHandler.REFUNDABLE] = false;
        this.checkboxStates.refundable[ExtraSearchHandler.REFUNDABLE] = true;
        this.applyFilter({ checked: true }, ExtraSearchHandler.REFUNDABLE, 'refundableRoomType');
      }

      if (defaults.nonRefundable) {
        this.searchParams.hiddenExtraFilters[ExtraSearchHandler.NON_REFUNDABLE] = false;
        this.checkboxStates.refundable[ExtraSearchHandler.NON_REFUNDABLE] = true;
        this.applyFilter(
          { checked: true },
          ExtraSearchHandler.NON_REFUNDABLE,
          'refundableRoomType'
        );
      }

      if (uiConfigHotelRatings?.hotelDefaultFilters.preferenceAgency) {
        this.checkboxStates.preference[SearchHandler.AGENCY] = true;
        this.applyFilter({ checked: true }, SearchHandler.AGENCY, 'preferred');
      }

      if (uiConfigHotelRatings?.hotelDefaultFilters.preferenceClient) {
        this.checkboxStates.preference[SearchHandler.CLIENT] = true;
        this.applyFilter({ checked: true }, SearchHandler.CLIENT, 'preferred');
      }

      if (uiConfigHotelRatings?.hotelDefaultFilters.inPolicy) {
        this.checkboxStates.travelPolicy[TravelPolicies.IN_POLICY] = true;
        this.applyFilter({ checked: true }, TravelPolicies.IN_POLICY, 'travelPolicy');
      }

      if (uiConfigHotelRatings?.hotelDefaultFilters.availableHotels) {
        this.checkboxStates.extra[SearchHandler.AVAILABILITY] = true;
        this.applyFilter({ checked: true }, SearchHandler.AVAILABILITY, 'extra');
      }

      if (uiConfigHotelRatings?.hotelDefaultFilters.tmcPreferred) {
        this.checkboxStates.preferenceRate[SearchHandler.TMC_PREFERRED] = true;
        this.applyFilter({ checked: true }, SearchHandler.TMC_PREFERRED, 'preferredRate');
      }

      if (uiConfigHotelRatings?.hotelDefaultFilters.companyPreferred) {
        this.checkboxStates.preferenceRate[SearchHandler.COMPANY_PREFERRED] = true;
        this.applyFilter({ checked: true }, SearchHandler.COMPANY_PREFERRED, 'preferredRate');
      }

      if (uiConfigHotelRatings?.hotelDefaultFilters.officePreferred) {
        this.checkboxStates.preferenceRate[SearchHandler.OFFICE_PREFERRED] = true;
        this.applyFilter({ checked: true }, SearchHandler.OFFICE_PREFERRED, 'preferredRate');
      }
    }
  }

  updateStates(): void {
    // Update most states from their corresponding filters using config
    this.filterStateConfig.forEach(({ stateKey, getItems, filterKey }) => {
      if (filterKey) {
        this.updateStateFromFilter(stateKey, getItems(), filterKey);
      }
    });

    // roomTypeList uses roomType filter but preference state
    this.updateStateFromFilter('preference', this.roomTypeList, 'roomType');

    // amenityTypes has special logic - checks both amenitytype AND accessibleRoomType
    this.amenityTypeListAdditional.forEach((item) => {
      this.checkboxStates.amenityTypes[item] =
        this.searchParams.filters.amenitytype.includes(item) ||
        this.searchParams.filters.accessibleRoomType.includes(item);
    });
  }

  clearFilters(): void {
    this.minPrice = 0;
    this.maxPrice = 0;
    this.searchParams.filters.perNightPriceRange.min = this.searchParams.filters.priceRange.min = 0;
    this.searchParams.filters.perNightPriceRange.max = this.searchParams.filters.priceRange.max =
      Number.MAX_SAFE_INTEGER;
    this.searchParams.resetFilters();
    this.searchParams.filterLighteningResults();
    this.initialiseStates();
    this.emitChange();
    console.log(this.checkboxStates.amenityTypes);
  }

  updatePrice() {
    if (+this.searchParams.filters.priceRange.max > +this.searchParams.filters.priceRange.min) {
      this.searchParams.filters.perNightPriceRange.max = this.searchParams.filters.priceRange.max =
        +this.maxPrice;
      this.searchParams.filters.perNightPriceRange.min = this.searchParams.filters.priceRange.min =
        +this.minPrice;
      this.emitChange();
    }
  }

  closeFiltersOptions(): void {
    this.viewControl.closeFilterOptions();
  }

  public applyFilter({ checked }, filterString: string, filterType: string): void {
    if (checked) {
      this.searchParams.addFilter(filterString, filtersKeys[filterType]);
    } else {
      this.searchParams.removeFilter(filterString, filtersKeys[filterType]);
    }

    this.searchParams.filterChange.next(true);
    this.emitChange();
  }

  // Search for the hotel name
  public onFilterChangeHotelName(): void {
    // @ts-ignore
    if (window.document.documentMode) {
      // On IE so delay the filter
      const context = this;
      clearTimeout(this.hotelNameTimeout);
      this.hotelNameTimeout = setTimeout(function () {
        context.searchParams.filterChange.next(true);
      }, 1500);
    } else {
      this.onFilterChange();
    }
  }

  public onFilterChange(): void {
    this.searchParams.filterChange.next(true);
  }

  trapFocus(event, i, array): void {
    if (i === array.length - 1) {
      event.preventDefault();
      const focusable = document
        .getElementById('filters')
        .querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
      // @ts-ignore
      focusable[0].focus();
    }
  }

  trapFocusReverse(event): void {
    event.preventDefault();
    const focusable = document
      .getElementById('filters')
      .querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    // @ts-ignore
    focusable[focusable.length - 1].focus();
  }

  emitChange() {
    this.searchParams.filterLighteningResults();
  }

  getExtraDisplayString(code: string) {
    if (code === SearchHandler.AVAILABILITY) {
      return 'Available Hotels';
    }
    return code;
  }

  setFocus(string) {
    setTimeout(() => {
      this.document.getElementById(string).focus();
    }, 0);
  }

  getAmenitiesDisplayText(code: string): string {
    switch (code) {
      case AmenitiesSearchHandler.SWIMMING_POOL:
        return 'Swimming Pool';
      case AmenitiesSearchHandler.WIFI:
        return 'Wifi';
      default:
        return code;
    }
  }
}
